import { clsx } from 'clsx'
import { Mark } from './logo'

function Row({ children }) {
  return (
    <div className="group relative">
      <div className="absolute inset-x-0 top-1/2 h-0.5 bg-linear-to-r from-gray-300 from-[2px] to-[2px] bg-[length:12px_100%]" />
      <div className="absolute inset-x-0 top-1/2 h-0.5 bg-linear-to-r from-white/15 from-[2px] to-[2px] bg-[length:12px_100%]" />
      <div className="absolute inset-x-0 bottom-0 h-0.5 bg-linear-to-r from-white/5 from-[2px] to-[2px] bg-[length:12px_100%] group-last:hidden" />
      {children}
    </div>
  )
}

function Logo({
  label,
  src,
  className,
}) {
  return (
    <div
      className={clsx(
        className,
        'absolute top-2 grid grid-cols-[1rem_1fr] items-center gap-2 px-3 py-1 whitespace-nowrap',
        'rounded-full bg-linear-to-t from-gray-800 from-50% to-gray-700 ring-1 ring-white/10 ring-inset',
        '[--move-x-from:-100%] [--move-x-to:calc(100%+100cqw)] [animation-iteration-count:infinite] [animation-name:move-x] [animation-play-state:paused] [animation-timing-function:linear] group-hover:[animation-play-state:running]',
      )}
    >
      <img alt="" src={src} className="size-4" />
      <span className="text-sm/6 font-medium text-white">{label}</span>
    </div>
  )
}

export function LogoTimelineFrontend() {
  return (
    <div aria-hidden="true" className="relative h-full overflow-hidden">
      <div className="[container-type:inline-size] absolute inset-0 grid grid-cols-1 pt-8">
        <Row>
          <Logo
            label="React.js"
            src="/assets/react.svg"
            className="[animation-delay:-26s] [animation-duration:30s]"
          />
          <Logo
            label="Next.js"
            src="/assets/next-js.svg"
            className="[animation-delay:-8s] [animation-duration:30s]"
          />
        </Row>
        <Row>
          <Logo
            label="TypeScript"
            src="/assets/typescript.svg"
            className="[animation-delay:-40s] [animation-duration:40s]"
          />
          <Logo
            label="JavaScript"
            src="/assets/javascript.svg"
            className="[animation-delay:-20s] [animation-duration:40s]"
          />
        </Row>
        <Row>
          <Logo
            label="Tailwind CSS"
            src="/assets/tailwind.svg"
            className="[animation-delay:-10s] [animation-duration:40s]"
          />
          <Logo
            label="Redux"
            src="/assets/redux.svg"
            className="[animation-delay:-32s] [animation-duration:40s]"
          />
        </Row>
        <Row>
          <Logo
            label="D3.js"
            src="/assets/d3.svg"
            className="[animation-delay:-45s] [animation-duration:45s]"
          />
          <Logo
            label="HighCharts"
            src="/assets/highcharts.svg"
            className="[animation-delay:-23s] [animation-duration:45s]"
          />
        </Row>
        <Row>
          <Logo
            label="HTML5"
            src="/assets/window.svg"
            className="[animation-delay:-55s] [animation-duration:60s]"
          />
          <Logo
            label="CSS3"
            src="/assets/file.svg"
            className="[animation-delay:-20s] [animation-duration:60s]"
          />
        </Row>
        <Row>
          <Logo
            label="Storybook"
            src="/assets/storybook.svg"
            className="[animation-delay:-9s] [animation-duration:40s]"
          />
          <Logo
            label="Vercel"
            src="/assets/vercel.svg"
            className="[animation-delay:-28s] [animation-duration:40s]"
          />
        </Row>
      </div>
    </div>
  )
} 